import moment from 'moment'
export const getDay = (text, withDay = false) => {
  let currentDate = moment(text)
  let date
  if (withDay) date = currentDate.format('DD/MM/YYYY')
  else date = currentDate.format('MM/YYYY')
  return date
}
